import { gql } from '@apollo/client';

export interface INewsResponse {
  news: {
    data: Array<{
      id: string;
      content: string;
      title: string;
      preview: string;
      url: string;
      createdAt: string;
    }>;
  };
}
export const NEWS = gql`
  query news {
    news(first: 5) {
      data {
        id
        content
        title
        preview
        url
        createdAt
      }
    }
  }
`;
